<style scoped lang="less">
@import 'modal.less';

.modal-item {
  .modal-item-base();
}
</style>

<template>
  <!-- 开启手机验证 - 开始 -->
  <Modal
    v-model="vis"
    :loading="true"
    :mask-closable="false"
    @on-cancel="cancelHandle"
    :title="$t('安全验证')"
  >
    <div class="modal-item">
      <h3>{{ $t('短信验证码') }}</h3>
      <div class="verify-code-box">
        <input type="text" v-model.trim="code.phone" />
        <verify-code
          class="verify-code"
          @click="sendSms"
          :rebase="vis"
        ></verify-code>
      </div>
      <div class="warn-tips">
        {{ $t('输入手机') }} {{ userInfo.mobilePhone | strEncrypt }}
        {{ $t('收到的验证码') }}
      </div>
    </div>
    <template #footer>
      <el-button @click="cancelHandle">{{ $t('取消') }}</el-button>
      <el-button
        type="primary"
        @click="okHandle"
        :loading="btnLoading.confirm"
        >{{ $t('确认') }}</el-button
      >
    </template>
  </Modal>
  <!-- 开启手机验证 - 结束 -->
</template>

<script>
import ModalBase from '@/components/ModalBase'
// 引入 vuex 中的用户信息
import { mapState } from 'vuex'
import {
  ajaxSmsHandle,
  ajaxTry,
  updateUserInfo,
  ajaxAlert,
  ajaxTip
} from '@/utils'
import { ajax_sendSms, ajax_openOrCloseSafeVerify } from '@/api/personal'

export default {
  name: 'OpenPhoneVerifyModal',
  extends: ModalBase,
  computed: {
    ...mapState(['userInfo'])
  },
  inject: {
    safeVerifyInfo: 'safeVerifyInfo',
    whetherVerify: 'whetherVerify'
  },
  data() {
    return {
      code: {
        phone: ''
      }
    }
  },
  mounted() {},
  methods: {
    async okHandle() {
      // 判断必要填写的验证码有没有空的，
      if (this.code.phone === '') {
        this.$Message.info(this.$t('请填写手机验证码！'))
        return
      }
      // 发送安全验证请求
      let ajaxParam = {
        ...this.safeVerifyInfo,
        ...{
          smsCode: this.code.phone
        }
      }
      this.btnLoading.confirm = true
      let [flag] = await ajaxTry(ajax_openOrCloseSafeVerify(ajaxParam))
        .then(ajaxAlert)
        .then(updateUserInfo)
      this.btnLoading.confirm = false
      if (flag) this.vis = false
    },
    cancelHandle() {
      // 改变外部的i-switch 状态
      let flag = this.whetherVerify[this.whetherVerify.currentISwitch]
      this.whetherVerify[this.whetherVerify.currentISwitch] = !flag
      this.vis = false
    },
    sendSms($event) {
      // 发送手机验证码
      ajaxSmsHandle(
        ajax_sendSms({
          phone: this.userInfo.mobilePhone,
          areaCode: this.userInfo.areaCode,
          smstype: this.safeVerifyInfo.smstype
        }),
        $event
      ).then(ajaxTip)
    }
  }
}
</script>
